var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { DynamicSvg, getTestId, IconButton, InView, isLastItem, isValidObject, Tooltip, Typography, WHITE } from '@airtel/air-design-system';
import { useEffect, useState } from 'react';
import { Image, View } from 'react-native';
import { getIconButtonGroupWidgetStyles } from './IconButtonGroupWidgetStyles';
export var IconButtonGroupWidgetComponent = props => {
  var _a;
  var _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data,
    id = props.id,
    onUserAction = props.onUserAction,
    _onPress = props.onPress,
    _props$showDynamicToo = props.showDynamicTooltip,
    showDynamicTooltip = _props$showDynamicToo === void 0 ? false : _props$showDynamicToo,
    _props$dynamicTooltip = props.dynamicTooltipProps,
    dynamicTooltipProps = _props$dynamicTooltip === void 0 ? {} : _props$dynamicTooltip,
    iconButtonWidgetProps = props.iconButtonWidgetProps,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'IconButtonGroupWidget' : _props$testID,
    accessibilityProps = props.accessibilityProps,
    showEmphasizer = props.showEmphasizer,
    emphasizerProps = props.emphasizerProps,
    _props$sendManualImpr = props.sendManualImpression,
    sendManualImpression = _props$sendManualImpr === void 0 ? false : _props$sendManualImpr,
    _props$itemsToBeShown = props.itemsToBeShownInRow,
    itemsToBeShownInRow = _props$itemsToBeShown === void 0 ? 4 : _props$itemsToBeShown,
    onIconButtonVisibleMetaData = props.onIconButtonVisibleMetaData,
    useNewStyle = props.useNewStyle,
    restProps = __rest(props, ["data", "id", "onUserAction", "onPress", "showDynamicTooltip", "dynamicTooltipProps", "iconButtonWidgetProps", "testID", "accessibilityProps", "showEmphasizer", "emphasizerProps", "sendManualImpression", "itemsToBeShownInRow", "onIconButtonVisibleMetaData", "useNewStyle"]);
  var iconButtonGroupWidgetStyles = getIconButtonGroupWidgetStyles(props);
  var _useState = useState(emphasizerProps === null || emphasizerProps === void 0 ? void 0 : emphasizerProps.imageUrl),
    imgUrl = _useState[0],
    setImgUrl = _useState[1];
  useEffect(() => {
    if (sendManualImpression) {
      data === null || data === void 0 ? void 0 : data.forEach((itemData, index) => {
        var actionData = (itemData === null || itemData === void 0 ? void 0 : itemData.onIconButtonVisibleMetaData) || onIconButtonVisibleMetaData;
        actionData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, actionData), Object.assign({
          index
        }, itemData)));
      });
    }
  }, []);
  var manipulateData = (rawData, chunkSize) => {
    var result = [];
    var totalRows = Math.ceil(rawData.length / chunkSize);
    rawData = rawData.map((item, index) => Object.assign(Object.assign({}, item), {
      index: index
    }));
    for (var i = 0; i < totalRows; i++) {
      result.push(rawData.slice(i * chunkSize, (i + 1) * chunkSize));
    }
    return result;
  };
  var mapIconButtonGroup = itemData => {
    var index = itemData.index;
    var isVisible = showDynamicTooltip && (dynamicTooltipProps === null || dynamicTooltipProps === void 0 ? void 0 : dynamicTooltipProps.index) === index;
    var iconButtonJsx = _jsx(IconButton, Object.assign({
      size: "md"
    }, itemData, accessibilityProps, iconButtonWidgetProps, getTestId(testID + "_" + index), {
      onPress: () => {
        var onPressData = itemData.onPress || _onPress;
        onPressData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onPressData), {
          index,
          itemData
        }));
      }
    }));
    return _jsxs(View, Object.assign({
      style: iconButtonGroupWidgetStyles.qabWrapper
    }, {
      children: [_jsx(Tooltip, Object.assign({}, dynamicTooltipProps, {
        style: [dynamicTooltipProps === null || dynamicTooltipProps === void 0 ? void 0 : dynamicTooltipProps.style, {
          zIndex: isVisible ? 1 : 0
        }],
        isVisible: isVisible
      }, {
        children: !sendManualImpression ? _jsx(InView, Object.assign({
          onChange: inView => {
            var actionData = (itemData === null || itemData === void 0 ? void 0 : itemData.onIconButtonVisibleMetaData) || onIconButtonVisibleMetaData;
            inView && actionData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
              id
            }, actionData), Object.assign({
              index
            }, itemData)));
          }
        }, {
          children: iconButtonJsx
        })) : _jsx(_Fragment, {
          children: iconButtonJsx
        })
      })), index === (emphasizerProps === null || emphasizerProps === void 0 ? void 0 : emphasizerProps.index) && showEmphasizer && isValidObject(emphasizerProps) && !(emphasizerProps === null || emphasizerProps === void 0 ? void 0 : emphasizerProps.hidePointer) && itemsToBeShownInRow > 0 && _jsx(View, {
        style: [iconButtonGroupWidgetStyles.emphasizerPointer]
      })]
    }), "icon_" + index + "_" + (itemData === null || itemData === void 0 ? void 0 : itemData.label));
  };
  var modifiedData = manipulateData(data, itemsToBeShownInRow);
  var numberOfBlankViewRequired = (_a = itemsToBeShownInRow - modifiedData[(modifiedData === null || modifiedData === void 0 ? void 0 : modifiedData.length) - 1].length) !== null && _a !== void 0 ? _a : 0;
  var renderBlankView = isLastRow => {
    if (isLastRow && numberOfBlankViewRequired > 0) return Array.from({
      length: numberOfBlankViewRequired
    }).map((_, idx) => _jsx(View, {
      style: iconButtonGroupWidgetStyles.qabWrapper,
      accessible: false
    }, "blank_view_" + idx));
  };
  return _jsx(_Fragment, {
    children: (modifiedData === null || modifiedData === void 0 ? void 0 : modifiedData.length) > 0 && modifiedData.map((itemData, index) => {
      var _a;
      var isLastRow = (_a = index === (modifiedData === null || modifiedData === void 0 ? void 0 : modifiedData.length) - 1) !== null && _a !== void 0 ? _a : false;
      var itemRow = Math.ceil(((emphasizerProps === null || emphasizerProps === void 0 ? void 0 : emphasizerProps.index) + 1) / itemsToBeShownInRow) - 1;
      var shouldShowEmphasizer = index == itemRow;
      return _jsxs(View, {
        children: [_jsxs(View, Object.assign({
          style: [iconButtonGroupWidgetStyles.qabDataContainer, (!shouldShowEmphasizer || !showEmphasizer) && !isLastItem(modifiedData, index) && iconButtonGroupWidgetStyles.qabDataContainerSpacer]
        }, restProps, {
          children: [itemData === null || itemData === void 0 ? void 0 : itemData.map(item => {
            return mapIconButtonGroup(item);
          }), useNewStyle && renderBlankView(isLastRow)]
        })), showEmphasizer && isValidObject(emphasizerProps) && shouldShowEmphasizer && _jsxs(View, Object.assign({
          style: iconButtonGroupWidgetStyles.emphasizerStrip
        }, {
          children: [!!(emphasizerProps === null || emphasizerProps === void 0 ? void 0 : emphasizerProps.iconName) && _jsx(DynamicSvg, Object.assign({
            fontSize: 16,
            iconName: emphasizerProps.iconName,
            color: WHITE,
            style: iconButtonGroupWidgetStyles.emphasizerIcon
          }, getTestId(testID, 'emphasizerIcon'))), !!(emphasizerProps === null || emphasizerProps === void 0 ? void 0 : emphasizerProps.imageUrl) && _jsx(Image, Object.assign({}, emphasizerProps === null || emphasizerProps === void 0 ? void 0 : emphasizerProps.imageProps, {
            source: {
              uri: imgUrl
            },
            style: [{
              width: 16,
              height: 16
            }, iconButtonGroupWidgetStyles.emphasizerIcon]
          }, getTestId(testID, 'emphasizerImageUrl'), {
            onError: () => {
              if (emphasizerProps === null || emphasizerProps === void 0 ? void 0 : emphasizerProps.onErrorImageUrl) setImgUrl(emphasizerProps === null || emphasizerProps === void 0 ? void 0 : emphasizerProps.onErrorImageUrl);
            }
          })), _jsx(Typography, {
            text: emphasizerProps === null || emphasizerProps === void 0 ? void 0 : emphasizerProps.text,
            type: "body-single-line-xs",
            color: WHITE
          })]
        }))]
      }, "single_row_item_" + index);
    })
  });
};
IconButtonGroupWidgetComponent.genericRendererKey = 'AirIconButtonGroupWidget';